import React, { Fragment, useState } from 'react';
import { Col, Dropdown, DropdownItem, DropdownMenu, DropdownToggle, Form, Row } from 'reactstrap';
import TextInput from '../../../components/InputFields/TextInput';
import { useFormik } from 'formik';
import "./ApplicationType.css";
import { formikAddApplicationType } from '../Constant';
import { failed, success } from '../../../utils/Tostify';
import { createApplicationType } from '../../../api/workflow';
import { useDispatch, useSelector } from 'react-redux';
import Loader from '../../../components/Loader/Loader';
import ImportApplicationType from './ImportApplicationType';

function AddApplicationType({setCurrentTab, direction, ...args }) {
    let token = useSelector(state => state.userReducer.token);
    const [dropdownOpenIndex, setDropdownOpenIndex] = useState(null); // Track which stage's dropdown is open
    const [isLoading, setIsLoading] = useState(false);
    const [showModal , setShowModal] = useState(false);
    const dispatch = useDispatch();

    const formik = useFormik({
        ...formikAddApplicationType,
        onSubmit: async (values) => {
            let res;
            try {
                setIsLoading(true);
                res = await createApplicationType({ values, dispatch, token });
                if (res?.status == "SUCCESS") {
                    setIsLoading(false);
                    success(res?.message);
                    formik.resetForm();
                    setCurrentTab("applicationTypeList");
                }else{
                    setIsLoading(false);
                    failed(res?.message);
                }
            } catch (error) {
                setIsLoading(false);
                failed(res?.message);
            }
        }
    });

    const handleAddStage = () => {
        const updatedStages = [
            ...formik.values.applicationStages,
            { name: '', child: [] }
        ];
        formik.setFieldValue('applicationStages', updatedStages);
    };

    const handleRemoveStage = (index) => {
        const updatedStages = formik.values.applicationStages.filter((_, i) => i !== index);
        formik.setFieldValue('applicationStages', updatedStages);
    };

    const handleStageChange = (index, value) => {
        const updatedStages = [...formik.values.applicationStages];
        updatedStages[index].name = value;
        formik.setFieldValue('applicationStages', updatedStages);
    };

    const handleAddChildStage = (index) => {
        const updatedStages = [...formik.values.applicationStages];
        updatedStages[index].child.push({ name: '' });
        formik.setFieldValue('applicationStages', updatedStages);
    };

    const handleRemoveChildStage = (stageIndex, childIndex) => {
        const updatedStages = [...formik.values.applicationStages];
        updatedStages[stageIndex].child = updatedStages[stageIndex].child.filter((_, i) => i !== childIndex);
        formik.setFieldValue('applicationStages', updatedStages);
    };

    const handleChildStageChange = (stageIndex, childIndex, value) => {
        const updatedStages = [...formik.values.applicationStages];
        updatedStages[stageIndex].child[childIndex].name = value;
        formik.setFieldValue('applicationStages', updatedStages);
    };

    const getApplicationTypeStages = (data)=>{
        formik.setFieldValue("applicationStages", data);
    };

    const toggleDropdown = (index) => {
        setDropdownOpenIndex(dropdownOpenIndex === index ? null : index);
    };
    return (
        <Fragment>
            {isLoading ? <Loader/> : null}
            {showModal ? <ImportApplicationType getApplicationTypeStages ={getApplicationTypeStages} setShowModal={() => setShowModal(!showModal)}/> : null}
            <div className="add_application_type">
                <Form onSubmit={formik.handleSubmit}>
                    <div className="first_block mb-0">
                        <h6 className="block_name text-center mt-0">Create Application Type</h6>
                        <Row>
                            <Col xl={8} className="location_block">
                                <TextInput
                                    keyField={"applicationTitle"}
                                    formik={formik}
                                    label="Application Type Name"
                                    type="text"
                                    value={formik.values.applicationTitle}
                                    onChange={(e) => formik.setFieldValue("applicationTitle", e.target.value)}
                                />
                            </Col>
                            <Col xl={4} className="location_block d-flex flex-column justify-content-center">
                                <div className="d-flex gap-2 justify-content-end button_workflow">
                                    <button
                                        className="save_btn import"
                                        type="button"
                                        onClick={()=> setShowModal(true)}
                                    >
                                        Import
                                    </button>
                                    <button
                                        className="save_btn import"
                                        type="button"
                                        onClick={handleAddStage}
                                    >
                                        Add Stage
                                    </button>
                                </div>
                            </Col>
                        </Row>
                        {formik.values.applicationStages.map((stage, stageIndex) => (
                                <div key={stageIndex}>
                                    {/* Parent Stage and First Child Stage in the same Row */}
                                    <Row>
                                        <Col lg={6} className="location_block d-flex align-items-center gap-3">
                                            <TextInput
                                                keyField={`stage-${stageIndex}`}
                                                formik={formik}
                                                label={`Parent Stage ${stageIndex + 1}`}
                                                type="text"
                                                value={stage.name}
                                                onChange={(e) => handleStageChange(stageIndex, e.target.value)}
                                            />
                                            <Dropdown
                                                isOpen={dropdownOpenIndex === stageIndex}
                                                toggle={() => toggleDropdown(stageIndex)}
                                                direction={direction}
                                                className="dropdown_blk"
                                            >
                                                <DropdownToggle caret size="xl" className="column_blk">
                                                    <div className="for_details">
                                                        <i className="fa fa-ellipsis-v"></i>
                                                    </div>
                                                </DropdownToggle>
                                                <DropdownMenu {...args}>
                                                    <DropdownItem className="d-flex gap-2 drop_block_content align-items-center">
                                                        <div
                                                            className="add_hosp"
                                                            type="button"
                                                            onClick={() => handleAddChildStage(stageIndex)}
                                                        >
                                                            Add Child Stage
                                                        </div>
                                                    </DropdownItem>
                                                    {formik.values.applicationStages.length > 1 && (
                                                        <DropdownItem className="d-flex gap-2 drop_block_content align-items-center">
                                                            <div
                                                                className="add_hosp"
                                                                type="button"
                                                                onClick={() => handleRemoveStage(stageIndex)}
                                                                disabled={formik.values.applicationStages.length === 1} // Disable delete button if only one stage left
                                                            >
                                                                Delete Stage
                                                            </div>
                                                        </DropdownItem>
                                                    )}
                                                </DropdownMenu>
                                            </Dropdown>
                                        </Col>
                                        {/* Render First Child Stage next to Parent Stage */}
                                        {stage.child.length > 0 && (
                                            <Col lg={6} className="location_block d-flex align-items-center gap-3 button_workflow">
                                                <TextInput
                                                    keyField={`childStage-${stageIndex}-0`}
                                                    formik={formik}
                                                    label="Child Stage 1"
                                                    type="text"
                                                    value={stage.child[0].name}
                                                    onChange={(e) => handleChildStageChange(stageIndex, 0, e.target.value)}
                                                />
                                                <span
                                                    className="material-symbols-outlined"
                                                    style={{ cursor: "pointer" }}
                                                    onClick={() => handleRemoveChildStage(stageIndex, 0)}
                                                >
                                                    delete
                                                </span>
                                            </Col>
                                        )}
                                    </Row>
                                    {/* Render Subsequent Child Stages Below */}
                                    {stage.child.slice(1).map((childStage, childIndex) => (
                                        <Row key={`child-${stageIndex}-${childIndex + 1}`}>
                                            <Col lg={6}></Col>
                                            <Col lg={6} className="location_block d-flex align-items-center gap-3 button_workflow">
                                                <TextInput
                                                    keyField={`childStage-${stageIndex}-${childIndex + 1}`}
                                                    formik={formik}
                                                    label={`Child Stage ${childIndex + 2}`}
                                                    type="text"
                                                    value={childStage.name}
                                                    onChange={(e) => handleChildStageChange(stageIndex, childIndex + 1, e.target.value)}
                                                />
                                                <span
                                                    className="material-symbols-outlined"
                                                    style={{ cursor: "pointer" }}
                                                    onClick={() => handleRemoveChildStage(stageIndex, childIndex + 1)}
                                                >
                                                    delete
                                                </span>
                                            </Col>
                                        </Row>
                                    ))}
                                </div>
                        ))}
                    </div>
                    <div className="d-flex gap-3 justify-content-center mt-3">
                        <button className="save_btn" type="submit">Save</button>
                        <button className="save_btn cancel_btn" type="button" onClick={()=> setCurrentTab("applicationTypeList")}>Cancel</button>
                    </div>
                </Form>
            </div>
        </Fragment>
    );
}

export default AddApplicationType;
